
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Header from './Header';
import Footer from './Footer';
import { Helmet } from "react-helmet";
import NotFound from './NotFound';
function BLogDetails() {
  const { slug } = useParams();
    const [blogdetails, setblogdetails] = useState(null);
    const [loading, setLoading] = useState(true);
      const [notFound, setNotFound] = useState(false);

  // Fetch package details
  // useEffect(() => {
  //   if (!slug) return;

  //   fetch(`https://planjourneysglobal.com/admin/api/blog_detail/${slug}`)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       if (data.status) {
  //         setblogdetails(data.data);
  //       } else {
  //         setblogdetails(null);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.error("Fetch Error:", err);
  //       setLoading(false);
  //     });
  // }, [slug]);
  useEffect(() => {
  if (!slug) return;

  setLoading(true);
  setNotFound(false);

  fetch(`https://planjourneysglobal.com/admin/api/blog_detail/${slug}`)
    .then((res) => res.json())
    .then((data) => {

      if (
        data?.status === true &&
        data?.data &&
        Object.keys(data.data).length > 0
      ) {
        setblogdetails(data.data);
      } else {
        setblogdetails(null);
        setNotFound(true);
      }

      setLoading(false);
    })
    .catch((err) => {
      console.error("Fetch Error:", err);

      setblogdetails(null);
      setNotFound(true);

      setLoading(false);
    });

}, [slug]);
    
 if (loading) return <p></p>;

if (notFound) return <NotFound />;
    return(

        <>
          <Helmet>
       {/* <title>{blogdetails.meta_keywords_title}</title> 
       <meta name="description" content={blogdetails.meta_description} /> */}
       {blogdetails.meta_keyword && <meta name="keywords" content={blogdetails.meta_keyword} />}
       {/* {blogdetails.slug && <link rel="canonical" href={blogdetails.slug} />}
 
   
       <meta property="og:title" content={blogdetails.meta_title} />
       <meta property="og:description" content={blogdetails.meta_description} />
       {blogdetails.slug && <meta property="og:url" content={blogdetails.slug} />}
       <meta property="og:type" content="website" />
 


 {blogdetails.banner_image_url && (
  <meta
    property="og:image"
    content={`${blogdetails.banner_image_url}`}
  />
)}

{blogdetails.banner_image_url && (
  <meta
    name="twitter:image"
    content={`${blogdetails.banner_image_url}`}
  />
)}
     
       <meta name="twitter:title" content={blogdetails.meta_title} />
       <meta name="twitter:description" content={blogdetails.meta_description} />
       <meta name="twitter:card" content="summary_large_image" /> */}
     </Helmet>
        <Header/>
  {/* Breadcrumb section Start*/}
  <div
    className="breadcrumb-section"
    style={{
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${blogdetails.banner_image_url})`
}}
  >
    <div className="container">
      <div className="banner-content">
        <h1>{blogdetails.blog_name}</h1>
      </div>
    </div>
  </div>
  {/* Breadcrumb section End*/}
  {/* Inspiration Details Page Start*/}
  <div className="inspiration-details-page pt-100 mb-100 mt-30">
    <div className="container">
      <div className="row g-lg-4 gy-5 justify-content-between">
        <div className="col-xl-8 col-lg-8">
          <div className="inspiration-details">
            {/* <h2>{blogdetails.blog_heading}</h2> */}
    
          <div dangerouslySetInnerHTML={{ __html: blogdetails.blog_detail}}/>
         <div  dangerouslySetInnerHTML={{ __html: blogdetails.blog_overview}}/>
            
          </div>
        </div>
        <div className="col-lg-4">
          <div className="package-details-page stricky">
  <div className="containers">
    <div className="row">
      <div className="col-lg-12">
        <div className="package-details-sidebar">
          <div className="customize-package-banner-wrap">
            <h2>
              <span>Customize</span> Travel Package!
            </h2>
            <ul>
              <li>
                <svg
                  width={18}
                  height={18}
                  viewBox="0 0 18 18"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx={9} cy={9} r="8.5" />
                  <path d="M13.6193 7.0722L8.05903 12.6355C7.97043 12.7211 7.85813 12.7655 7.74593 12.7655C7.68772 12.7656 7.63008 12.7541 7.57632 12.7318C7.52256 12.7095 7.47376 12.6768 7.43272 12.6355L4.38073 9.5835C4.20642 9.4121 4.20642 9.1315 4.38073 8.9572L5.45912 7.8758C5.62462 7.7104 5.92002 7.7104 6.08552 7.8758L7.74593 9.5362L11.9146 5.3645C11.9557 5.32334 12.0045 5.29068 12.0581 5.26837C12.1118 5.24606 12.1694 5.23455 12.2275 5.2345C12.3456 5.2345 12.4579 5.2818 12.5406 5.3645L13.619 6.446C13.7936 6.6203 13.7936 6.9009 13.6193 7.0722Z" />
                </svg>
                Make Your Favourite Package
              </li>
              <li>
                <svg
                  width={18}
                  height={18}
                  viewBox="0 0 18 18"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx={9} cy={9} r="8.5" />
                  <path d="M13.6193 7.0722L8.05903 12.6355C7.97043 12.7211 7.85813 12.7655 7.74593 12.7655C7.68772 12.7656 7.63008 12.7541 7.57632 12.7318C7.52256 12.7095 7.47376 12.6768 7.43272 12.6355L4.38073 9.5835C4.20642 9.4121 4.20642 9.1315 4.38073 8.9572L5.45912 7.8758C5.62462 7.7104 5.92002 7.7104 6.08552 7.8758L7.74593 9.5362L11.9146 5.3645C11.9557 5.32334 12.0045 5.29068 12.0581 5.26837C12.1118 5.24606 12.1694 5.23455 12.2275 5.2345C12.3456 5.2345 12.4579 5.2818 12.5406 5.3645L13.619 6.446C13.7936 6.6203 13.7936 6.9009 13.6193 7.0722Z" />
                </svg>
                Enjoy Your Trip
              </li>
            </ul>
            <a
              href="/contact"
              
              className="primary-btn1 two black-bg"
            >
              <span>
                Enquiry Now
                <svg
                  width={10}
                  height={10}
                  viewBox="0 0 10 10"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z" />
                </svg>
              </span>
              <span>
               Enquiry Now
                <svg
                  width={10}
                  height={10}
                  viewBox="0 0 10 10"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z" />
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

         </div>
      </div>
    </div>
  </div>
  {/* Inspiration Details Page End*/}

        <Footer/> 
        </>

        
    )
}
export default BLogDetails;